import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useSingleSaleTableStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            display: 'flex',
            flexDirection: 'column',
            paddingTop: 24,
            paddingBottom: 24,

            [theme.breakpoints.up('md')]: {
                paddingTop: '45px',
                paddingBottom: '45px'
            }
        },
        boxTitle: {
            paddingBottom: 16,

            [theme.breakpoints.up('md')]: {
                paddingBottom: '45px'
            }
        },
        title: {
            fontSize: 20,
            lineHeight: 1,
            fontWeight: 600,
            marginBottom: 8
        },
        subtitle: {
            fontSize: 14,
            lineHeight: 1.4,

            [theme.breakpoints.up('md')]: {
                fontSize: 16
            }
        },
        optionsButtonContainer: {
            marginTop: 26,
            marginBottom: 35
        },
        notesSection: {
            marginRight: 32,
            marginBottom: 0,
            width: '60%',

            [theme.breakpoints.down('sm')]: {
                marginRight: 0,
                marginBottom: 16,
                width: '100% !important'
            },

            [theme.breakpoints.down('md')]: {
                width: '50%'
            },

            [theme.breakpoints.down('lg')]: {
                width: '46%'
            }
        },
        boxBottom: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            width: '100%',
            marginTop: 32,

            [theme.breakpoints.down('sm')]: {
                flexDirection: 'column',
                alignItems: 'stretch',
                marginTop: 15
            }
        },
        boxButton: {
            [theme.breakpoints.down('sm')]: {
                flex: '0 0 100%'
            }
        },
        addLineButton: {
            '& button': {
                [theme.breakpoints.down('sm')]: {
                    'height': 47,
                    'padding': '0px 22px',

                    '& .MuiButton-endIcon': {
                        'marginLeft': 8,
                        'marginRight': 0,

                        '& svg': {
                            width: 14,
                            height: 14
                        }
                    }
                }
            }
        },
        boxPayment: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
            minWidth: 320,
            maxWidth: 400,
            width: '100%',
            marginLeft: 0,
            paddingTop: 0,

            [theme.breakpoints.down('sm')]: {
                width: '100%',
                minWidth: 0,
                maxWidth: '100%',
                alignItems: 'stretch',
                marginLeft: 0,
                marginTop: 24
            },
            [theme.breakpoints.up('md')]: {
                paddingTop: 0,
                marginLeft: 0
            }
        },

        actionsRow: {
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 12,
            width: '100%',

            [theme.breakpoints.down('sm')]: {
                gap: 10
            },

            [theme.breakpoints.up('md')]: {
                marginTop: '30px'
            }
        },
        editActionButton: {
            [theme.breakpoints.down('sm')]: {
                'height': 55,
                'flex': 1,
                'borderRadius': 30,

                '& span': {
                    fontSize: 18,
                    fontWeight: 600
                }
            }
        },
        payButton: {
            [theme.breakpoints.down('sm')]: {
                'height': 55,
                'marginTop': 8,
                'borderRadius': 30,

                '& span': {
                    fontSize: 18,
                    fontWeight: 600
                }
            },
            [theme.breakpoints.up('md')]: {
                marginTop: '30px'
            }
        }
    })
);
